import * as React from 'react';
import { RadioButton } from 'wix-ui-tpa/cssVars';
import { getDataAttributes } from '../../../common/utils';
import type {
  IWutRadioButtonProps,
  IWutRadioButtonImperativeActions,
} from '../WutRadioButton.types';
import { st, classes } from './style/WutRadioButton.component.st.css';

const WutRadioButton: React.ForwardRefRenderFunction<
  IWutRadioButtonImperativeActions,
  IWutRadioButtonProps
> = (props, ref) => {
  const {
    radioGroupName,
    value,
    checked,
    id,
    className,
    stylableClassName,
    isDisabled,
    onChange,
    onFocus,
    onBlur,
    ariaAttributes,
  } = props;

  const radioButtonRef = React.useRef<RadioButton>(null);

  React.useImperativeHandle(ref, () => ({
    focus: () => {
      radioButtonRef.current?.focus();
    },
    blur: () => {
      radioButtonRef.current?.blur();
    },
  }));

  return (
    <div id={id} className={className} {...getDataAttributes(props)}>
      <RadioButton
        disabled={isDisabled}
        value={value}
        name={radioGroupName}
        checked={checked}
        className={st(classes.srOnly, stylableClassName)}
        aria-describedby={ariaAttributes?.describedBy}
        aria-labelledby={ariaAttributes?.labelledBy}
        aria-label={ariaAttributes?.label}
        // @ts-expect-error TODO: fix onChange type in wix-ui-core
        onChange={onChange}
        onFocus={onFocus}
        onBlur={onBlur}
        ref={radioButtonRef}
      />
    </div>
  );
};

export default React.forwardRef(WutRadioButton);
